<div class="bg-surface dark:bg-surface-darkmode flex justify-center">
  <div class="w-full max-w-[1280px] py-2 mx-2 flex gap-3 items-center">
    <ng-content />
    <div class="flex-1 flex flex-col">
      <h1 class="text-base font-medium leading-6 line-clamp-1">
        {{ document() | documentFilename }}
      </h1>
      <span
        class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-xs font-normal leading-4"
      >
        {{ document().createdAt | date: 'dd.MM.yyyy - HH:mm' }}
        {{ 'cockpit.documents.preview.header.oclock' | transloco }}
      </span>
    </div>
    <ui-button
      mode="outlined"
      (click)="shareDialog.showModal()"
      class="flex-none"
      disableInDemoMode
    >
      <ng-icon name="heroShare" size="20" slot="start" class="!block" />
      {{ 'cockpit.documents.preview.header.share' | transloco }}
    </ui-button>
  </div>
</div>

<ui-simple-dialog #shareDialog [lazy]="true">
  @if (shareDialog.isOpen()) {
    <app-document-share-dialog
      class="w-full block"
      [document]="document()"
      [organizationID]="organizationId()"
      (clickCancel)="shareDialog.close()"
    />
  }
</ui-simple-dialog>
